import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UzurvPipesModule } from '@uzurv/core';
import { LocationModule } from '../location/location.module';
import { FavoriteLocationListItemComponent } from './favorite-location-list-item/favorite-location-list-item.component';

@NgModule({
  imports: [CommonModule, MatProgressSpinnerModule, MatButtonModule, MatIconModule, LocationModule, FormsModule, UzurvPipesModule],
  declarations: [FavoriteLocationListItemComponent],
  exports: [FavoriteLocationListItemComponent]
})
export class FavoriteLocationsModule {}
